import React, { useState, useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { format } from 'date-fns';
import { ChevronRight } from 'lucide-react';
import { RiDeleteBin6Line } from "react-icons/ri";
import { useGlobalContext } from '../../../Context/GlobalContext';
import Cookies from "js-cookie";
import { usePayrollContext } from '../../../Context/PayrollContext';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const PayrollReimbrusmentTotal = ({
  staff
    }) => {

  const {handleEditReimbursement,isOffCanvasOpen,setIsOffCanvasOpen} = usePayrollContext();
  // Calculate total reimbursement
  const totalReimbursement = staff?.staffDetails?.SalaryDetails[0]?.Reimbursement?.reduce(
    (total, item) => total + item.amount,
    0
  ) || 0;

  const sidebarRef = useRef(null);


  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOffCanvasOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsOffCanvasOpen]);
  

  return (
    <div
    ref={sidebarRef}
    className={`fixed top-[56px] right-0 h-screen sm:w-[400px] w-full z-[99] shadow-cs bg-white payroll-sidebar shadow-lg transform transition-transform duration-300 ${isOffCanvasOpen ? "translate-x-0" : "translate-x-full"}`}
    >
      <div className="relative w-full h-full">
        {/* Header */}
        <div className="flex justify-between items-center border-gray-200 p-4 border-b">
          <div className="flex items-center gap-2">
            <h2 className="font-semibold text-[#000] text-[18px]">
              {staff?.name || 'Staff Name'}
            </h2>
          </div>
          <button className="text-[black]" onClick={()=>setIsOffCanvasOpen(false)}>
            <CloseIcon />
          </button>
        </div>

        {/* Content */}
        <div className="flex flex-col h-[calc(100%-64px)] overflow-auto">
          {/* Current Month Section */}
          <div className="p-4 border-b">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm text-gray-600">
                {format(new Date(), 'MMMM yyyy')}
              </span>
            </div>
          </div>

          {/* Paid Section */}
          <div className="p-4 border-b bg-gray-50">
            <div className="flex justify-between items-center">
              <span className="font-normal text-muted-foreground text-sm">Reimburement</span>
              <span className="font-normal text-muted-foreground text-sm pr-8">₹ {totalReimbursement.toFixed(2)}</span>
            </div>
          </div>

          {/* Reimbursement List */}
          <div className="flex-1 overflow-auto">
            {staff?.staffDetails?.SalaryDetails[0]?.Reimbursement?.map((item) => (
              <div  key={item.id} className="p-4 border-b hover:bg-gray-50">
                <div className="flex justify-between items-center">
                  <div className="flex flex-col">
                    <span className="text-sm font-light">
                      {format(new Date(item.date), 'dd MMM, yyyy')}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className=" font-light text-muted-foreground text-sm">₹ {item.amount.toFixed(2)}</span>
                    <KeyboardArrowRightIcon className=" bg-[#e5e7eb96] p-[3px] rounded-[40px]" onClick={() => {handleEditReimbursement(item)}}/>
                  </div>
                </div>
              </div>
            ))}

            {(!staff?.staffDetails?.SalaryDetails[0]?.Reimbursement || 
              staff.staffDetails.SalaryDetails[0].Reimbursement.length === 0) && (
              <div className="p-4 text-center text-gray-500">
                No reimbursements found
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollReimbrusmentTotal;